<template lang="html">
  <div>
    <router-view/>
  </div>
</template>

<script>
import {mapActions} from 'vuex'
export default {
    methods:{
        ...mapActions([
            'createPage'
        ]),
        buttonClick: function () {
            this.createPage({
                "title":"Titulo album",
                "author":"autor nome",
                "cover_file":"ABC",
                "release_date":"2020-08-11",
                "serial":1,
                "spotify_widget":"spotify link aqui"
            })
        }
    }
}
</script>

<style lang="css" scoped>
</style>
